import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AssetManager from '../components/assets';
import store from '../store/store';
import DragContext from '../utils/dragDropContext';

const assetsPlugin = function (editor, url) {

    editor.settings.file_picker_callback = function(callback, value, meta) {

        let currentAsset = null; // The asset that the user has clicked on
        let isAssetDeleted = null; // A flag to determine whether an asset has just been deleted

        const extractAsset = (asset) => {
            // So we can keep track of asset currently clicked on
            currentAsset = asset;
        }

        const updateCurrentAsset = (oldAssetKey, newAssetKey) => {
            /**
             * The current asset url needs to be modified to reflect
             * the asset rename. We need to do this because keyed-file-browsers
             * renderDetail function is not triggered when an asset is modified.
             */
            const assetUrlAndFolder = currentAsset.replace(oldAssetKey,'');
            currentAsset = assetUrlAndFolder + newAssetKey;
        }

        const insertAsset = () => {
            if(isAssetDeleted !== currentAsset) {
                callback(currentAsset, null);
                $('#assets-modal').modal('hide');
            }
        }

        const markCurrentAssetAsDeleted = () => {
            isAssetDeleted = currentAsset;
        }

        const AssetsWithDragContext = DragContext(AssetManager);

         ReactDOM.render(
            <div id="assets-modal" className="modal fade" tabindex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="modal-title">Asset Manager</h4>
                        </div>
                        <div className="modal-body">
                            <Provider store={store}>
                                <AssetsWithDragContext onAssetSelect={extractAsset} onAssetUpdate={updateCurrentAsset} onAssetDelete={markCurrentAssetAsDeleted} />
                            </Provider>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="button" onClick={insertAsset} className="btn btn-primary">Insert Asset</button>
                        </div>
                    </div>
                </div>
            </div>, document.getElementById('generic-modal'));

        $('#assets-modal').modal('show');

        $('#assets-modal').on('hidden.bs.modal', function () {
            ReactDOM.unmountComponentAtNode(document.getElementById('generic-modal'))
        });
    }
};

export default assetsPlugin;
